var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ul',{staticClass:"nav nav-tabs delivery-requests-nav-tabs",attrs:{"id":"delivery-requests-tabs"}},_vm._l((_vm.navTabs),function(item){return _c('li',{key:item.id,class:_vm.activeTab(item.id),attrs:{"id":item.id},on:{"click":function($event){_vm.changeTab(item.id)}}},[_c('a',[_vm._v(_vm._s(item.name))])])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-124a121a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/deliveryRequests/NavTabs.vue
// module id = null
// module chunks = 